import React, {Component} from 'react'
//import Paper from 'material-ui/Paper'
import PlayersComponent from '../../players/PlayersComponent'
import Dialog from 'material-ui/Dialog';


class NewGameSettings extends Component {


  render() {
    return (
        <Dialog open={true} autoScrollBodyContent={true} >
          <PlayersComponent />
        </Dialog>
    );
  }
}


export default NewGameSettings;



// WEBPACK FOOTER //
// ./src/game/board/components/NewGameSettings.jsx